import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { 
  FREE_TRIAL_EXPIRED_MESSAGE, 
  FREE_TRIAL_EXPIRING_SOON_MESSAGE,
  SUBSCRIPTION_EXPIRED_MESSAGE 
} from '../actions/constants/subscriptionConstants';

interface SubscriptionBannerProps {
  className?: string;
}

const SubscriptionBanner: React.FC<SubscriptionBannerProps> = ({ className }) => {
  const navigate = useNavigate();
  
  const subscriptionStatus = useSelector((state: any) => state.userSubscriptionStatusReducer);
  const { data, isLoading } = subscriptionStatus;
  if (isLoading || !data) {
    return null;
  }

  

  const { isExpired, isExpiringSoon, daysRemaining, planName } = data;
  const isFreeTrial = planName?.toLowerCase().includes('free');

  // Don't show banner if subscription is active and not expiring soon
  if (!isExpired && !isExpiringSoon) {
    return null;
  }

  const getMessage = () => {
    if (isExpired) {
      return isFreeTrial ? FREE_TRIAL_EXPIRED_MESSAGE : SUBSCRIPTION_EXPIRED_MESSAGE;
    }
    if (isExpiringSoon && daysRemaining !== null) {
      const daysText = (daysRemaining === 1) ? '1 day' : `${daysRemaining} days`;
      return isFreeTrial 
        ? `${FREE_TRIAL_EXPIRING_SOON_MESSAGE} (${daysText} remaining)`
        : `Your subscription is expiring in ${daysText}. Renew now to continue.`;
    }
    return null;
  };

  const message = getMessage();
  if (!message) return null;

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  return (
    <Alert
      message={message}
      type={isExpired ? 'error' : 'warning'}
      showIcon
      className={className}
      action={
        <Button 
          size="small" 
          type={isExpired ? 'primary' : 'default'}
          danger={isExpired}
          onClick={handleUpgrade}
        >
          {isExpired ? 'Upgrade Now' : 'View Plans'}
        </Button>
      }
      banner
    />
  );
};

export default SubscriptionBanner;
